/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthenticationSchema { 
    type?: AuthenticationSchema.TypeEnum;
    name?: string;
    description?: string;
    specUri?: string;
    documentationUri?: string;
}
export namespace AuthenticationSchema {
    export const TypeEnum = {
        Oauth: 'oauth',
        Oauth2: 'oauth2',
        Oauthbearertoken: 'oauthbearertoken',
        Httpbasic: 'httpbasic',
        Httpdigest: 'httpdigest'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


